import { render, staticRenderFns } from "./OrganisationOverview.vue?vue&type=template&id=15428fa2&scoped=true&"
import script from "./OrganisationOverview.vue?vue&type=script&lang=js&"
export * from "./OrganisationOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationOverview.vue?vue&type=style&index=0&id=15428fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15428fa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
